import { createContext, useContext } from 'react';

export const GlobalContext = createContext();

const useGlobalContext = () => useContext(GlobalContext);

export default useGlobalContext;
